import { _itmAxios } from '@/plugins/axios/itmAxios';

/**
 * @description : 수강신청코드 api 확인
 * @returns : Promise
 */
const checkItmCode = code => {
  return _itmAxios.get(`external/sugang/code-check?code=${code}`, {});
};

export { checkItmCode };
